module.exports = __webpack_public_path__ + "static/media/image2.a9747407.png";